import { date, eq, number, option, string } from 'fp-ts'
import { pipe } from 'fp-ts/lib/function'
import * as t from 'io-ts'
import { Fraction } from '../../types/Fees'

export type Nullable<T extends object> = { [K in keyof T]: T[K] | null }

export const NewTax = t.type({
  name: t.string,
  rate: Fraction,
  description: t.string,
})
export type NewTax = t.TypeOf<typeof NewTax>

export const Tax = t.type({
  id: t.number,
  name: t.string,
  rate: Fraction,
  description: t.string,
})
export type Tax = t.TypeOf<typeof Tax>

export type TaxesSearchRequest = {
  page: number
  itemsPerPage: number
  after?: Date
  before?: Date
}

export const Taxes = t.type({
  data: t.array(Tax),
  count: t.number,
})
export type Taxes = t.TypeOf<typeof Taxes>

export const emptyTaxes: Taxes = {
  data: [],
  count: 0,
}

const getEqNullable = <T>(o: eq.Eq<T>): eq.Eq<T | null | undefined> =>
  pipe(option.getEq(o), eq.contramap(option.fromNullable))

export const eqNullableNumber = getEqNullable(number.Eq)
export const eqNullableString = getEqNullable(string.Eq)
export const eqNullableDate = getEqNullable(date.Eq)

export const eqSearchRequest = eq.struct<TaxesSearchRequest>({
  itemsPerPage: eqNullableNumber,
  page: eqNullableNumber,
  after: eqNullableDate,
  before: eqNullableDate,
})

export type State = {}
